<div class="states-process">
  @if (typeView !== 'changeStateModal') {
    <div class="states-process__block-header">
      @if (skin === 'dark-blue') {
        <span class="states-process__title-process"
          [afTranslate]="type === 'normalTask'?'states-task-help.task-states':'public-link.process-management'">_Gestión del proceso</span>
      }@else if (skin === 'icam-red') {
        <span class="states-process__title-process">
          <span [afTranslate]="'concept-instances-list.entry'">_Entrada</span>:
          <span>{{statesProcess.concept.creationDate | convertDate:''}}</span>
        </span>
      }
      <button class="common-button__text-noborder"
        (click)="showProcessModal()"
        [disabled]="previewView">
        <span class="common-button__text-title"
          [afTranslate]="'states-process.complete-process'">_Proceso completo</span>
        <i class="common-icon__md"
          [ngClass]="type === 'normalTask'?'lf-icon-open-window':'lf-icon-open-window'"></i>
      </button>
    </div>
  }
  @if(type === 'normalTask'){
    <div class="evaluation-styles__container-styles">
      @for (state of statesProcess.statesList; track $index) {
        <div [ngClass]="{'evaluation-styles__active-container': state.stateActive,
            'evaluation-styles__middlend-container': !state.stateActive,
            'evaluation-styles__active-container--expand': state.stateActive && (state.stateType == 'open' || state.stateType == 'stand-by')}">
          @if (state.stateActive) {
            @if(isLanding){
              <div class="evaluation-styles__active-container-title landing-page__tablet">
                <button-with-menu-action
                  [style.visibility]="$index > 0 ? 'visible' : 'hidden'"
                  [icon]="'lf-icon-arrow-round-left'"
                  [item]="statesProcess.prevStateListItem"
                  (launchActionEmitter)="changeProcessQuestion($event.option, 'task')">
                </button-with-menu-action>
                <span class="evaluation-styles__label-active">
                  {{state.state}}
                </span>
                <button-with-menu-action
                  [style.visibility]="!statesProcess.summary?.next?.length && statesProcess.statesList.length ? 'visible' : 'hidden'"
                  [icon]="'lf-icon-arrow-round-right'"
                  [item]="statesProcess.nextStateListItem"
                  (launchActionEmitter)="changeProcessQuestion($event.option, 'task')">
                </button-with-menu-action>
              </div>
            }
            <span
              class="evaluation-styles__label-active"
              [ngClass]="{
                'landing-page__desktop': isLanding
              }">
              {{state.state}}
            </span>
          }
          <hr [ngClass]="{'evaluation-styles__active-section-line': state.stateActive,
            'evaluation-styles__middlend-section-line': !state.stateActive,
            'evaluation-styles__color-section-line--open': state.stateType == 'open',
            'evaluation-styles__color-section-line--progress': state.stateType == 'progress',
            'evaluation-styles__color-section-line--stand-by': state.stateType == 'stand-by',
            'evaluation-styles__color-section-line--resolved': state.stateType == 'resolved',
            'evaluation-styles__color-section-line--closed': state.stateType == 'closed',
            'evaluation-styles__color-section-line--closed-unresolved': state.stateType == 'closed-unresolved' }" />
          @if (!state.stateActive) {
            <button class="stepper-advance__process-styles"
              [disabled]="state.disabledState"
              (click)="changeProcessQuestion(state, 'task')">
              <i class="stepper-advance__icon"
                [ngClass]="{'lf-icon-arrow-round-right': state.nextState,
                  'lf-icon-arrow-round-left': state.prevState}">
              </i>
              <span class="stepper-advance__text">
                {{state.state}}
              </span>
            </button>
          }
        </div>
      }
    </div>
  }@else if (statesProcess.showStates) {
    <div class="evaluation-styles__container-styles">
      @if (statesProcess.summary?.previous) {
        <div class="evaluation-styles__middlend-container">
          <hr class="evaluation-styles__middlend-section-line">
          <button class="stepper-advance__process-styles"
            (click)="changeProcessQuestion(statesProcess.summary?.previous, 'previous')"
            [disabled]="!statesProcess.canChangeState">
            <i class="lf-icon-arrow-round-left stepper-advance__icon"></i>
            <span-tooltip class="stepper-advance__text"
              [text]="statesProcess.summary?.previous?.stateName">
            </span-tooltip>
          </button>
        </div>
      }
      <div class="evaluation-styles__active-container"
        [ngClass]="{'evaluation-styles__active-container--expand': !statesProcess.summary?.previous || !statesProcess.summary?.next?.length}">
        @if (isLanding) {
          <div class="evaluation-styles__active-container-title landing-page__tablet">
            <button-with-menu-action
              [style.visibility]="statesProcess.summary?.previous ? 'visible' : 'hidden'"
              [icon]="'lf-icon-arrow-round-left'"
              [item]="statesProcess.prevStateListItem"
              (launchActionEmitter)="changeProcessQuestion($event.option, 'previous')">
            </button-with-menu-action>
            <span class="evaluation-styles__label-active">
              {{statesProcess.summary?.current?.name}}
            </span>
            <button-with-menu-action
              [style.visibility]="statesProcess.summary?.next?.length ? 'visible' : 'hidden'"
              [icon]="'lf-icon-arrow-round-right'"
              [item]="statesProcess.nextStateListItem"
              (launchActionEmitter)="changeProcessQuestion($event.option, 'next')">
            </button-with-menu-action>
          </div>
        }
        <span
          class="evaluation-styles__label-active"
          [ngClass]="{
            'landing-page__desktop': isLanding
          }">
          {{statesProcess.summary?.current?.name}}
        </span>
        <hr class="evaluation-styles__active-section-line">
      </div>
      @if (statesProcess.summary?.next?.length) {
        <div class="evaluation-styles__middlend-container">
          <hr class="evaluation-styles__middlend-section-line">
          @for (nextItem of statesProcess.summary?.next; track $index) {
            @if (($index + 1) <= statesProcess.maxStatesShowed || (($index + 1) > statesProcess.maxStatesShowed && statesProcess.showAll)) {
              <button
                class="stepper-advance__process-styles"
                (click)="changeProcessQuestion(nextItem, 'next')"
                [disabled]="!statesProcess.canChangeState">
                <i class="lf-icon-arrow-round-right stepper-advance__icon">
                </i>
                <span-tooltip
                  class="stepper-advance__text"
                  [text]="nextItem.stateName">
                </span-tooltip>
              </button>
            }
          }
          @if (statesProcess.summary?.next?.length > statesProcess.maxStatesShowed) {
            <button
              class="common-button__expand-toned"
              (click)="statesProcess.showAll = !statesProcess.showAll">
              <i
                class="common-icon__md"
                [ngClass]="statesProcess.showAll ? 'lf-icon-angle-up' : 'lf-icon-angle-down'">
              </i>
              <span
                class="common-button__expand-label-text"
                [afTranslate]="statesProcess.showAll ? 'task-concept-list.see-less-options' : 'task-concept-list.see-more-options'">
              </span>
            </button>
          }
        </div>
      }
    </div>
  }
</div>
